import { render, staticRenderFns } from "./access-list.vue?vue&type=template&id=491c613b&"
import script from "./access-list.vue?vue&type=script&lang=js&"
export * from "./access-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports